import React from 'react';

import { Button, TitleWithDescription, InfoBox, Chip } from '@infoods/lifebase-ui';
import { useToggle } from 'react-use';
import { observer } from 'mobx-react';

import classes from './EntityLoginIdBlock.module.scss';

import { ChangeLoginIdModal } from './ChangeLoginIdModal/ChangeLoginIdModal';
import { useEntityLoginId } from './hooks/useEntityLoginId';
import { getDescriptionInfo } from './utils/getDescriptionInfo';
import { loggedInUserDataStore } from '../../../../../../../shared/stores/loggedInUserDataStore';

type EntityLoginIdBlockProps = {
  entityId: number;
};

const EntityLoginIdBlock = observer(({ entityId }: EntityLoginIdBlockProps) => {
  const [isShowChangeLoginIdModal, toggleShowChangeLoginIdModal] = useToggle(false);
  const { loginId, updateLoginId } = useEntityLoginId(entityId);
  const { isInbodyAdmin, getUserRole } = loggedInUserDataStore;

  const userRole = getUserRole();

  const description = getDescriptionInfo(userRole);

  return (
    <>
      <InfoBox title="Login ID">
        <div className={classes.row}>
          <TitleWithDescription
            title={
              <div className={classes.titleRow}>
                <span>Current Login ID:</span>
                <Chip label={loginId} size="small" className="private-info" />
              </div>
            }
            description={description}
            titleFont="body-14-bold"
          />
          {!isInbodyAdmin && (
            <Button
              variant="outlined"
              size="small"
              onClick={toggleShowChangeLoginIdModal}
            >
              Change Login ID
            </Button>
          )}
        </div>
      </InfoBox>
      <ChangeLoginIdModal
        open={isShowChangeLoginIdModal}
        onSubmit={updateLoginId}
        onClose={toggleShowChangeLoginIdModal}
      />
    </>
  );
});

export { EntityLoginIdBlock };
